const orderTypes = {
	externalOrder: 'External Order',
};

export { orderTypes };
